import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';

export const useUpgradeModal = () => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const { user, getTrialInfo, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    const shouldShowModal = () => {
      // Mostrar apenas para usuários logados com trial expirado (2 dias para novos, 3 para antigos)
      if (user && user.plan === 'free' && !user.isSubscribed) {
        const trialInfo = getTrialInfo();
        return trialInfo.status === 'trial_expired';
      }
      // Não mostrar para desconectados nem assinantes ativos
      return false;
    };

    // Verificar se deve mostrar o modal a cada 2 segundos
    const interval = setInterval(() => {
      if (shouldShowModal()) {
        setShowUpgradeModal(true);
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [user, isLoading, getTrialInfo]);

  const closeUpgradeModal = () => {
    setShowUpgradeModal(false);
  };

  return {
    showUpgradeModal,
    closeUpgradeModal
  };
};